//入库计划单

export default [

    {   //入库计划单（客户端）
        path: "inbound/billclient",
        name: "inboundBillclient",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billclient/index"),
    },

    {   //update 入库计划（客户端）
        path: "inbound/billclient/update/:type",
        name: "inboundBillclientDetail",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billclient/update"),
    },

    {   // 入库计划 装箱
        path: "inbound/billclient/boxing",
        name: "inboundBillclientBoxing",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billclient/boxing"),
    },
    // {   // 库内管理
    //     path: "inbound/inventory",
    //     name: "inboundInventory",
    //     component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/inventorymanage/index"),
    // },
    {   // 入库计划单(管理端)
        path: "inbound/billmanage",
        name: "inboundBillmanage",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billmanage/index"),
    },
    {   //update 入库计划(管理端)
        path: "inbound/billmanage/update/:type",
        name: "inboundBillmanageDetail",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billclient/update"),
    },
     {   // 入库计划 装箱
        path: "inbound/billmanage/boxing",
        name: "inboundBillmanageBoxing",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/billclient/boxing"),
    },
    {   // 入库执行单
        path: "inbound/order",
        name: "inboundOrder",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/order/index"),
    },
    {   // 入库执行单
        path: "inbound/order/update/:type",
        name: "inboundOrderDetail",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/inbound/order/update"),
    },
    {
        path: "inbound/winitReceipt",
        name: "inboundWinitReceipt",
        component: () => import(/* webpackChunkName: "product" */ "@/views/inbound/winitReceipt"),
    },
    {   // 无来源入库
        path: "unsourced/order",
        name: "unsourcedInbound",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/unsourcedinbound/index"),
    },
    {   // 无来源入库（管理）
        path: "unsourced/manage/order",
        name: "unsourcedInboundManage",
        component: () => import(/* webpackChunkName: "inbound" */ "@/views/unsourcedinbound/manageindex"),
    },
]


